import { render } from "./addBbyMbErp.vue?vue&type=template&id=6136fb25&scoped=true"
import script from "./addBbyMbErp.vue?vue&type=script&lang=js"
export * from "./addBbyMbErp.vue?vue&type=script&lang=js"

import "./addBbyMbErp.vue?vue&type=style&index=0&id=6136fb25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6136fb25"]])

export default __exports__